import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import WidgetInfoSettings from '../../settings_sidebar/WidgetInfoSettings.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import { fetchJson } from '../../../../helpers/fetch.js';
import SelectSetting from '../../settings_sidebar/common/SelectSetting.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';

import {
  project_portfolio_preset_dashboard_presets_path
} from '~/routes';

function ProjectListWidgetSettings({widgetId}) {
  const settings = useSelector(s => s.dashboard.widgets[widgetId].settings) || {};
  const setWidgetAttribute = useSetWidgetAttribute(widgetId);

  const setAttribute = (p, v) => {
    setWidgetAttribute(`settings.${p}`, v);
  };

  const {data: presets = [] } = useQuery({
    queryKey: ['task-portfolio-presets'],
    queryFn:  () => fetchJson(project_portfolio_preset_dashboard_presets_path()),
    enabled: true
  });

  const props = {
    selectedObject: settings,
    setAttribute: setAttribute,
    hideDescription: true
  };
  
  return (<>
    <hr />
    <CollapsibleSection title={I18n.t('content_settings')}>
      <WidgetTitleSettings widgetId={widgetId} />
      <WidgetInfoSettings widgetId={widgetId} />
      <SelectSetting {...props} attr='preset_id' label={I18n.t('column_preset')} isClearable={true} options={presets} />
    </CollapsibleSection>
  </>);
};

export default ProjectListWidgetSettings;
